import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import {
  isRequired,
  arrayMultiIsRequired,
  validateEndDate,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import DatePicker from '../../../common/forms/input/DatePicker';
import ServiceTypeSelect from '../../../common/forms/select/ServiceTypeSelect';
import RouteSelect from '../../../common/forms/select/RouteSelect';
import TollSelect from '../../../common/forms/select/TollSelect';

const FORM_NAME = 'TollExtraordinaryAssignmentForm';

const validateEndDateField = (value, allValues) =>
  validateEndDate(value, allValues.startDate);

export const TollExtraordinaryAssignmentForm = ({ handleSubmit, saving }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Tipo de Servicio" required>
        <Field
          name="serviceTypeIds"
          component={ServiceTypeSelect}
          placeholder="Tipo de Servicio"
          showAll
          isMulti
          validate={[arrayMultiIsRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Ruta" required>
        <Field
          name="routeId"
          component={RouteSelect}
          placeholder="Ruta"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Fecha Inicial" required>
        <Field
          name="startDate"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Fecha Final" required>
        <Field
          name="endDate"
          component={DatePicker}
          validate={[isRequired, validateEndDateField]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Peajes Extraordinarios" required>
        <Field
          name="tollIds"
          component={TollSelect}
          isMulti
          onlyExtraordinary
          validate={[arrayMultiIsRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormFooter saveButtonDisabled={saving} />
  </Form>
);

TollExtraordinaryAssignmentForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ RouteUnit }) => ({
  saving: !RouteUnit.TollExtraordinaryAssignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: FORM_NAME,
})(TollExtraordinaryAssignmentForm);

export default connect(mapStateToProps)(formComponent);
